
import pageMixin from "@/mixins/pageMixin"
import LandingPage from "@/components/LandingPage"

export default {
  components: {
    LandingPage
  },
  mixins: [pageMixin],
  asyncData({ $storyblokHelper }) {
    return $storyblokHelper.get({ id: "about" })
  }
}
